var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NumbershapeTable"},[_c('div',{staticClass:"grid"},_vm._l((_vm.items),function(ref){
var number = ref.number;
var label = ref.label;
return _c('div',{key:number,staticClass:"Item"},[_c('div',{staticClass:"Numbershape"},[_c('AnimatedNumbershape',{attrs:{"number":number,"play":""}})],1),_c('div',{staticClass:"caption"},[_vm._v("\n                "+_vm._s(label)+"\n            ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }